import { NgIf } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { takeUntil } from 'rxjs/operators';
import { twoFactorAuthErrorAction, twoFactorInvalidCodeAction } from '../../../shared/actions/auth.actions';
import { AbstractComponent } from '../../../shared/components/abstract.component';
import { LandingDialogTitleComponent } from '../../../shared/components/dialogs/landing-dialog-title/landing-dialog-title.component';
import { TwoFaInputComponent } from '../../../shared/components/two-fa-input/two-fa-input.component';
import { SUPPORT_EMAIL } from '../../../shared/links';
import { TwoFaType } from '../../../shared/models/api/auth.model';
import { TurnstileService } from '../../../shared/services/turnstile.service';

@Component({
  selector: 'bp-two-fa-login-dialog',
  templateUrl: './two-fa-login-dialog.component.html',
  styleUrls: ['./two-fa-login-dialog.component.scss'],
  standalone: true,
  imports: [LandingDialogTitleComponent, NgIf, TwoFaInputComponent],
})
export class TwoFaLoginDialogComponent extends AbstractComponent implements AfterViewInit, OnDestroy {
  @Input() twoFaType: TwoFaType;
  @Input() twoFAErrorMessage: string;
  @Input() twoFAErrorShown: boolean;
  @Input() isInputDisabled = false;
  @Output() tokenFilled: EventEmitter<{ token2FA: string; turnstileToken: string }> = new EventEmitter();
  supportEmail = SUPPORT_EMAIL;
  turnstileToken: string | null = null;
  turnstileWidgetId: string | undefined;

  private readonly elementRef = inject(ElementRef);
  private readonly turnstileService = inject(TurnstileService);
  private readonly actions = inject(Actions);

  constructor() {
    super();

    this.actions
      .pipe(ofType(twoFactorInvalidCodeAction, twoFactorAuthErrorAction), takeUntil(this.unsubscribe$))
      .subscribe(() => {
        if (window.turnstile && this.turnstileWidgetId) {
          window.turnstile.remove(this.turnstileWidgetId);
          this.turnstileToken = null;
          this.initTurnstile();
        }
      });
  }

  ngAfterViewInit(): void {
    this.initTurnstile();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.turnstileWidgetId && window.turnstile) {
      window.turnstile.remove(this.turnstileWidgetId);
    }
  }

  initTurnstile(): void {
    this.turnstileService
      .initializeTurnstileScriptAndWidget(this.elementRef, this.unsubscribe$)
      .then(({ turnstileWidgetId, turnstileToken }) => {
        this.turnstileWidgetId = turnstileWidgetId;
        this.turnstileToken = turnstileToken;
      });
  }
}
